import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useAlertContext } from "../../alert/AlertContext";
import { FormikErrorNotificationProps } from "./FormikErrorNotification.types";

export function FormikErrorNotification(props: FormikErrorNotificationProps) {
  const { formik } = props;
  const { isValid, isValidating, isSubmitting } = formik;
  const { showFormValidationError, closeAlert } = useAlertContext();
  const { t } = useTranslation();
  const alertIdRef = useRef<string | null>(null);

  const handleClick = useCallback(() => {
    if (alertIdRef.current) {
      closeAlert(alertIdRef.current);
    }
    alertIdRef.current = null;

    const firstInvalidField = document.querySelector<HTMLElement>('[aria-invalid="true"]');
    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalidField.focus({ preventScroll: true });
    }
  }, [closeAlert]);

  useEffect(() => {
    if (!isValid && !isValidating && isSubmitting) {
      if (alertIdRef.current) {
        closeAlert(alertIdRef.current);
      }
      alertIdRef.current = showFormValidationError(t("common.formValidationError"), handleClick);
    }
  }, [isSubmitting, isValid, isValidating, showFormValidationError, handleClick, closeAlert, t]);

  return null;
}
